import oc from "open-color";

export const STALE_COLOR = oc.gray[6];
